import { FC, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';

import { DiscoverNewClinicsModal, getDiscoverNewClinicsListItem } from '../discover-new-clinics';
import { getInviteAllListItem, InviteAllModal } from '../invite-all';

import { TModalState } from './types.ts';

import styles from './styles.module.scss';

export const ActionsButton: FC = () => {
    const [modalState, setModalState] = useState<TModalState>({
        discover: false,
        invite: false,
    });
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const menuItems: MenuProps['items'] = [
        getInviteAllListItem({
            onOpenModal: () => {
                setModalState((prevState) => ({ ...prevState, invite: true }));
                setDropdownOpen(false);
            },
        }),
        getDiscoverNewClinicsListItem({
            onOpenModal: () => {
                setModalState((prevState) => ({ ...prevState, discover: true }));
                setDropdownOpen(false);
            },
        }),
    ];

    return (
        <>
            <Dropdown
                menu={{ items: menuItems }}
                placement="bottomRight"
                trigger={['click']}
                open={dropdownOpen}
                onOpenChange={(open, info) => {
                    if (info.source === 'trigger') {
                        setDropdownOpen(open);
                    }
                }}
                rootClassName={styles.actionsDropdown}
            >
                <Button
                    className={styles.actionsButton}
                    type="primary"
                    color="blue"
                    icon={dropdownOpen ? <UpOutlined /> : <DownOutlined />}
                >
                    Action
                </Button>
            </Dropdown>
            <InviteAllModal
                open={modalState.invite}
                onClose={() => setModalState((prevState) => ({ ...prevState, invite: false }))}
            />
            <DiscoverNewClinicsModal
                open={modalState.discover}
                onClose={() => setModalState((prevState) => ({ ...prevState, discover: false }))}
            />
        </>
    );
};
